<template>
<div class="">
  <div class="">
    <div class="">
      <img :src="singleInventory.thumbnail" alt="" width="100%">
      <v-btn :depressed="true" block @click="removeThumbnailImage()" small color="error">Remove Thumbnail</v-btn>
      <div class="contact-stat">
        <my-upload
          field="file"
          v-model="showThumbnail"
          :width="830"
          :height="526"
          :url="thumbnailUrl()"
          @crop-upload-success="imageuploaded"
          :noCircle="true"
          lang-type="en">
        </my-upload>
        <v-btn :depressed="true" block @click="showThumbnail = true">Add Thumbnail Image</v-btn>
      </div>
    </div>
    <div class="panel-body">
      <div class="contact-stat">
        <my-upload
          field="file"
          v-model="showSlider"
          :width="1904"
          :height="830"
          :url="sliderUrl()"
          @crop-upload-success="activityImages"
          :noCircle="true"
          lang-type="en">
        </my-upload>
        <v-btn :depressed="true" block @click="showSlider = true">Other Inventory Images</v-btn>
      </div>
      <div class="row">
        <div class="col-md-4" v-for="(image, key) in inventoryImages" :key="key">
          <img :src="image.path" alt="" width="100%">
          <v-btn :depressed="true" @click="removeImage(image.public_id)" small block color="error">Remove</v-btn>
        </div>
      </div>
    </div>

  </div>
</div>
</template>

<script>
import InventoryVuex from '../../../mixins/Computed/Inventory/InventoryVuex'
import myUpload from 'vue-image-crop-upload'
export default {
  name: 'inventory-images',
  data () {
    return {
      showBanner: false,
      showThumbnail: false,
      showSlider: false
    }
  },
  methods: {
    removeImage (imageId) {
      var data = {
        public_id: imageId,
        inventory_id: this.$route.params.inventory_id
      }
      this.$store.dispatch('delete_activity_image', data)
    },
    removeThumbnailImage () {
      this.$store.dispatch('delete_thumbnail_activity_image', this.$route.params.inventory_id)
    },
    imageuploaded: function () {
      this.$store.dispatch('get_activity', this.$route.params.inventory_id)
    },
    activityImages: function () {
      this.$store.dispatch('get_activity_images', this.$route.params.inventory_id)
    },
    thumbnailUrl: function () {
      return this.$imageUniversalUrl() + ':5002/inventory/thumbnail/' + this.$route.params.inventory_id
    },
    sliderUrl: function () {
      return this.$imageUniversalUrl() + ':5002/inventory/images/' + this.$route.params.inventory_id
    }
  },
  components: {
    myUpload
  },
  mixins: [InventoryVuex]
}
</script>

<style scoped>

</style>
